import { Component, Input } from '@angular/core';
import { HOLE_SUBSETS, TiebreakerMethodKey, TiebreakerPath } from '../../../models/games/tiebreaker.models';

/**
 * Inline badge/indicator shown next to a tiebreaker winner's name.
 * Hidden when entry has no tiebreakerWinner flag set.
 *
 * Usage:
 *   <s18-tiebreaker-indicator [entry]="row"></s18-tiebreaker-indicator>
 */
@Component({
  selector: 's18-tiebreaker-indicator',
  templateUrl: './tiebreaker-indicator.component.html',
  styleUrls: ['./tiebreaker-indicator.component.scss']
})
export class TiebreakerIndicatorComponent {

  @Input() entry: {
    tiebreakerWinner?: boolean;
    tiebreakerMethod?: string;
    tiebreakerPath?: string;
  };

  expanded = false;

  get visible(): boolean {
    return !!this.entry?.tiebreakerWinner;
  }

  get resolutionSummary(): string {
    if (!this.entry) return '';

    const pathLabel = this.getPathLabel(this.entry.tiebreakerPath as TiebreakerPath);
    const methodLabel = this.getMethodLabel(this.entry.tiebreakerMethod as TiebreakerMethodKey);

    if (this.entry.tiebreakerPath === 'playoff') {
      return 'Won via Playoff';
    }

    return `Won via ${pathLabel} — ${methodLabel}`;
  }

  toggle(): void {
    this.expanded = !this.expanded;
  }

  private getPathLabel(path: TiebreakerPath | undefined): string {
    switch (path) {
      case 'usga_cascade': return 'USGA Cascade';
      case 'manual': return 'Manual Scorecard';
      case 'playoff': return 'Playoff';
      default: return 'Tiebreaker';
    }
  }

  private getMethodLabel(method: TiebreakerMethodKey | undefined): string {
    if (!method || method === 'playoff') return '';
    const subset = HOLE_SUBSETS.find(s => s.key === method);
    return subset ? subset.label : method;
  }
}
